export default __webpack_public_path__ + "static/media/manage_subscription.ad9915ee.svg";